define([
	'require',
	'jquery',
	'pubsub'
], function(require, $) {
	$.pubsub('subscribe', 'SHOPCART_UPDATED', function ( msg, data ) {
		data = data || {};
		//eligibility = {
		//	orderId: {string},
		//	rewardOptionEligible: {boolean}
		//	rewardsAdded: {boolean}
		//}

		// Default the object incase we are missing data
		data.rewardEligibility = data.rewardEligibility || {};
		
		var eligibility = data.rewardEligibility;
		eligibility.orderId = eligibility.orderId || '';
		eligibility.rewardOptionEligible = typeof eligibility.rewardOptionEligible === 'boolean' ? eligibility.rewardOptionEligible : false;
		eligibility.rewardsAdded = typeof eligibility.rewardsAdded === 'boolean' ? eligibility.rewardsAdded : false;

		if(eligibility.rewardOptionEligible && !eligibility.rewardsAdded) {
			// Let everyone know the free gift offer is loading
			$.pubsub('publish', 'vfdp.wcs.free_gift.offer_loading');
			require(['wcs.free-gift'], function(freeGift) {
				$('#freeGiftModal').freeGiftModal('open', eligibility.orderId);
			});
		} else if(!eligibility.rewardOptionEligible) {
			// Remove the gift if it's not eligible
			$('.freeGiftItem').each(function(){
				$(this).html('');
				$(this).removeClass('freeGiftItem');
				$(this).removeClass('checkout-item-table-item-js');
			});
		}
	});
});
